/* tslint:disable */
"format global";

const domHighlightCss = "text-highlight";

const makeRegex = function (words: any, options: any) {
    const settings = { caseSensitive: false, wordsOnly: false, stopList: "" };
    $.extend(settings, options);

    if (words.constructor === String) {
        words = [words];
    }

    words = $.grep(words, function (word: string, i: number) {
        return word !== "";
    });

    words = $.map(words, function (word: string, i: number) {
        return word.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    });

    const wordsToRemove = settings.stopList.split(",");
    words = _.difference(words, wordsToRemove);

    if (words.length === 0) { return this; };

    const flag = settings.caseSensitive ? "" : "i";
    let pattern = "(" + words.join("|") + ")";
    if (settings.wordsOnly) {
        pattern = "(?:\\b)" + pattern + "(?:\\b)";
    }

    return new RegExp(pattern, flag);
};

$.extend({
    highlight: (node: any, regex: any, nodeName: string, className: string) => {
        if (node.nodeType === 3) {
            const match = node.data.match(regex);
            if (match) {
                const highlight = document.createElement(nodeName || "span");
                highlight.className = className || domHighlightCss;
                const wordNode = node.splitText(match.index);
                wordNode.splitText(match[0].length);
                const wordClone = wordNode.cloneNode(true);
                highlight.appendChild(wordClone);
                wordNode.parentNode.replaceChild(highlight, wordNode);
                return 1; // skip added node in parent
            }
        } else if ((node.nodeType === 1 && node.childNodes) && // only element nodes that have children
            !/(script|style)/i.test(node.tagName) && // ignore script and style nodes
            !(node.tagName === nodeName.toUpperCase() && node.className === className)) { // skip if already highlighted
            for (let i = 0; i < node.childNodes.length; i++) {
                i += $.highlight(node.childNodes[i], regex, nodeName, className);
            }
        }
        return 0;
    }
});

$.fn.unhighlight = function (options: any) {
    const settings = { className: domHighlightCss, element: "span" };
    $.extend(settings, options);

    return this.find(settings.element + "." + settings.className).each(function () {
        const parent = this.parentNode;
        parent.replaceChild(this.firstChild, this);
        parent.normalize();
    }).end();
};

$.fn.highlight = function (words: any, options: any) {
    const settings = { className: domHighlightCss, element: "span", caseSensitive: false, wordsOnly: false, stopList: "" };
    $.extend(settings, options);

    const regex = makeRegex(words, options);

    return this.each(function () {
        jQuery.highlight(this, regex, settings.element, settings.className);
    });
};

$.fn.hasMatches = function (words: any, options: any) {
    let found = false;
    let matched: any;
    const settings = { className: domHighlightCss, element: "span", caseSensitive: false, wordsOnly: false, stopList: "" };
    $.extend(settings, options);

    const regex = makeRegex(words, options);

    this.each(function () {
        matched = $(this).text().match(regex);

        if (matched && matched.length > 0) {
            found = true;
        }

        if (found) { return false; } // break the loop
    });

    return found;
};

export default $;


// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/shared/plugins/highlight.ts